import { NgModule } from '@angular/core';

import { SupportNumberRoutingModule } from './support-number-routing.module';
import { SupportNumberComponent } from './support-number.component';
import { CustomLayoutModule } from '../../custom-layout/custom-layout.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { MaterialModule } from 'src/app/shared/modules/materia.module';
import { AssetUrlModule } from 'src/pipes/asset-url.module';


@NgModule({
  declarations: [SupportNumberComponent],
  imports: [
    SupportNumberRoutingModule,
    CustomLayoutModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule,
    AssetUrlModule
  ],
  providers: [
    CustomizationService
  ],
})
export class SupportNumberModule { }
